import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Link,
} from "react-router-dom";
import Main from "./Main";
import styled from "styled-components";

import { CiSearch } from "react-icons/ci";
import { CiMail } from "react-icons/ci";
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineLanguage } from "react-icons/md";
import { Container } from "./style";
import BG from "./bg.png";
import Logo from "./logo.png";
import { useTranslation } from "react-i18next";

import Footer from "./Footer.jsx";

//pages
import News1 from "./pages/News1.jsx";
import News2 from "./pages/News2.jsx";
import News3 from "./pages/News3.jsx";
import News4 from "./pages/News4.jsx";
import News5 from "./pages/News5.jsx";
import News6 from "./pages/News6.jsx";
import News7 from "./pages/News7.jsx";
import News8 from "./pages/News8.jsx";
import News9 from "./pages/News9.jsx";
import News10 from "./pages/News10.jsx";
import News11 from "./pages/News11.jsx";
import News12 from "./pages/News12.jsx";
import News13 from "./pages/News13.jsx";
import News14 from "./pages/News14.jsx";
import News15 from "./pages/News15.jsx";
import News16 from "./pages/News16.jsx";
import News17 from "./pages/News17.jsx";

import ActionPlan from "./pages/ActionPlan";
import BankList from "./pages/BankList";
import BanksReview from "./pages/BanksReview";
import BankStatistic from "./pages/BankStatistic";
import CallCenter from "./pages/CallCenter.jsx";
import ClubProgramm from "./pages/ClubProgramm";
import ClubStructure from "./pages/ClubStructure";
import EduCenter from "./pages/EduCenter";
import EduPresentation from "./pages/EduPresentation";
import FAQ from "./pages/FAQ";
import FinanceSystem from "./pages/FinanceSystem";
import ForceTask from "./pages/ForceTask";
import Goals from "./pages/Goals";
import MacroEco from "./pages/MacroEco";
import Members from "./pages/Members";
import MoneyCredit from "./pages/MoneyCredit";
import OrgStructure from "./pages/OrgStructure";
import Requzite from "./pages/Requzite";
import Docs from "./pages/Docs";
import AboutUs from "./pages/AboutUs";
import Structure from "./pages/Structure";

const HeaderStyled = styled.div`
  height: 400px;
  background-image: url(${BG});
  background-size: cover;
  color: #fff;

  @media (max-width: 768px) {
    height: auto;
    min-height: 400px;
    padding-bottom: 30px;
  }

  > div {
    .tophead {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 15px;
        text-align: center;
      }

      img {
        @media (max-width: 768px) {
          max-width: 200px;
        }
      }

      .search {
        margin-top: 20px;
        display: flex;
        align-items: center;
        gap: 10px;

        @media (max-width: 768px) {
          margin-top: 10px;
        }
      }

      > div {
        display: flex;
        column-gap: 20px;

        @media (max-width: 768px) {
          justify-content: center;
        }

        > div {
          display: flex;
          column-gap: 10px;
          align-items: center;
          font-size: 17px;
        }
      }
    }
  }

  > nav {
    padding: 10px 0;
    background: rgba(51, 51, 51, 0.5);

    @media (max-width: 768px) {
      padding: 30px 0 0;
    }

    > div {
      > ul.menu {
        display: flex;
        justify-content: space-between;
        list-style: none;
        padding: 0;
        margin: 0;

        @media (max-width: 768px) {
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }

        > li {
          position: relative;
          padding: 10px;

          &:hover .dropdown {
            display: block;
          }

          span {
            cursor: pointer;
            white-space: nowrap;
          }

          .dropdown {
            display: none;
            position: absolute;
            background: rgba(51, 51, 51, 0.9);
            min-width: 200px;
            padding: 10px 0;
            z-index: 1000;

            @media (max-width: 768px) {
              position: static;
              background: rgba(51, 51, 51, 0.7);
              width: 100%;
              text-align: center;
            }

            li {
              padding: 8px 15px;

              &:hover {
                background: rgba(255, 255, 255, 0.1);
              }

              a {
                color: #fff;
                text-decoration: none;
                display: block;
              }
            }
          }
        }
      }
    }
  }

  h1 {
    font-size: 40px;
    margin-top: 50px;

    @media (max-width: 768px) {
      font-size: 28px;
      margin-top: 30px;
      text-align: center;
    }
  }

  p {
    font-size: 24px;
    margin-top: 27px;

    @media (max-width: 768px) {
      font-size: 18px;
      margin-top: 15px;
      text-align: center;
    }
  }
`;

const App = () => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const toggleLanguage = () => {
    // Определяем текущий язык
    const currentLanguage = i18n.language;
    // Меняем язык
    const newLanguage = currentLanguage === "ru" ? "tj" : "ru";
    i18n.changeLanguage(newLanguage);
  };
  const location = useLocation();

  const getHeaderContent = () => {
    const pathToKey = {
      "/about-us": "aboutUs",
      "/docs": "docs",
      "/structure": "structure",
      "/org-structure": "orgStructure",
      "/members": "members",
      "/requzite": "requzite",
      "/policy": "policy",
      "/money-credit": "moneyCredit",
      "/goals": "goals",
      "/action-plan": "actionPlan",
      "/banks-reviews": "banksReviews",
      "/banks-lists": "banksList",
      "/force-task": "forceTask",
      "/edu-center": "eduCenter",
      "/edu-presentation": "eduPresentation",
      "/call-center": "callCenter",
      "/faq": "faq",
    };

    const key = pathToKey[location.pathname] || "default";

    return {
      h1: t(`headers.${key}.h1`),
      p: t(`headers.${key}.p`),
    };
  };

  const { h1, p } = getHeaderContent();

  return (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <HeaderStyled>
        <Container>
          <div
            className="tophead"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Link to="/">
              <img src={Logo} />
            </Link>

            <div style={{ marginTop: "20px" }} className="search">
              Поиск
              <CiSearch />
            </div>

            <div>
              {/* <div>
                <CiMail />
                abt@abt.tj
              </div> */}

              {/* <div>
                <MdOutlinePhone />
                44 600 70 40
              </div> */}

              <div
                onClick={toggleLanguage}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MdOutlineLanguage size={24} style={{ marginRight: "8px" }} />
                {i18n.language === "ru" ? "РУС" : "TОЧ"}
              </div>
            </div>
          </div>
        </Container>

        <nav>
          <Container>
            <ul className="menu">
              <li>
                <span>
                  <Link to="/about-us">{t("menu.aboutUs")}</Link>
                </span>
                <ul className="dropdown">
                  <li>
                    <Link to="/docs">{t("menu.foundingDocs")}</Link>
                  </li>
                  <li>
                    <Link to="/structure">{t("menu.structure")}</Link>
                  </li>
                  <li>
                    <Link to="/org-structure">{t("menu.orgStructure")}</Link>
                  </li>
                  <li>
                    <Link to="/members">{t("menu.members")}</Link>
                  </li>
                  <li>
                    <Link to="/requzite">{t("menu.requisites")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <span>{t("menu.monetaryPolicy")}</span>
                <ul className="dropdown">
                  <li>
                    <Link to="/money-credit">{t("menu.strategy")}</Link>
                  </li>
                  <li>
                    <Link to="/goals">{t("menu.goalsAndObjectives")}</Link>
                  </li>
                  <li>
                    <Link to="/action-plan">{t("menu.actionPlan")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <span>{t("menu.financialSystem")}</span>
                <ul className="dropdown">
                  <li>
                    <Link to="/banks-reviews">{t("menu.bankReviews")}</Link>
                  </li>
                  <li>
                    <Link to="/banks-lists">{t("menu.bankMembers")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <span>{t("menu.statistics")}</span>
                <ul className="dropdown">
                  <li>
                    <Link to="/macro-eco">{t("menu.macroIndicators")}</Link>
                  </li>
                  <li>
                    <Link to="/bank-stat">{t("menu.bankStats")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <span>{t("menu.bankersClub")}</span>
                <ul className="dropdown">
                  <li>
                    <Link to="/force-task">{t("menu.position")}</Link>
                  </li>
                  <li>{t("menu.clubStructure")}</li>
                  <li>{t("menu.clubProgram")}</li>
                </ul>
              </li>
              <li>
                <span>{t("menu.eduCenter")}</span>
                <ul className="dropdown">
                  <li>
                    <Link to="/edu-center">{t("menu.trainingPlan")}</Link>
                  </li>
                  <li>
                    <Link to="/edu-presentation">
                      {t("menu.presentations")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <span>{t("menu.financialOmbudsman")}</span>
                <ul className="dropdown">
                  <li>
                    <Link to="/call-center">{t("menu.callCenter")}</Link>
                  </li>
                  <li>
                    <Link to="/faq">{t("menu.faq")}</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </Container>
        </nav>

        <Container>
          <h1 style={{ fontSize: "40px", marginTop: "50px" }}>{h1}</h1>
          <p style={{ fontSize: "24px", marginTop: "27px" }}>{p}</p>
        </Container>
      </HeaderStyled>

      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/structure" element={<Structure />} />
        <Route path="/org-structure" element={<OrgStructure />} />
        <Route path="/members" element={<Members />} />
        <Route path="/requzite" element={<Requzite />} />

        <Route path="/money-credit" element={<MoneyCredit />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/action-plan" element={<ActionPlan />} />

        <Route path="/banks-reviews" element={<BanksReview />} />
        <Route path="/banks-lists" element={<BankList />} />

        <Route path="/force-task" element={<ForceTask />} />
        <Route path="/banks-lists" element={<BankList />} />
        <Route path="/banks-lists" element={<BankList />} />

        <Route path="/edu-center" element={<EduCenter />} />
        <Route path="/edu-presentation" element={<EduPresentation />} />

        <Route path="/call-center" element={<CallCenter />} />
        <Route path="/faq" element={<FAQ />} />

        <Route path="/macro-eco" element={<MacroEco />} />
        <Route path="/bank-stat" element={<BankStatistic />} />

        <Route path="/news1" element={<News1 />} />
        <Route path="/news2" element={<News2 />} />
        <Route path="/news3" element={<News3 />} />
        <Route path="/news4" element={<News4 />} />
        <Route path="/news5" element={<News5 />} />
        <Route path="/news6" element={<News6 />} />
        <Route path="/news7" element={<News7 />} />
        <Route path="/news8" element={<News8 />} />
        <Route path="/news9" element={<News9 />} />
        <Route path="/news10" element={<News10 />} />

        <Route path="/news11" element={<News11 />} />
        <Route path="/news12" element={<News12 />} />
        <Route path="/news13" element={<News13 />} />

        <Route path="/news14" element={<News14 />} />
        <Route path="/news15" element={<News15 />} />
        <Route path="/news16" element={<News16 />} />
        <Route path="/news17" element={<News17 />} />
      </Routes>

      <Footer />
    </div>
  );
};

export default App;
